package dev.danko.roblox_craft_ai.pages

import com.varabyte.kobweb.compose.css.Overflow
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.ui.styleModifier
import dev.danko.roblox_craft_ai.uikit.icons.AppIcon
import dev.danko.roblox_craft_ai.state.AuthState
import dev.danko.roblox_craft_ai.components.SiteSection
import dev.danko.roblox_craft_ai.components.SiteHeader
import dev.danko.roblox_craft_ai.components.SiteFooter
import dev.danko.roblox_craft_ai.uikit.components.LanguageSwitcher
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.uikit.i18n.AppLocale
import dev.danko.roblox_craft_ai.state.Txt
import dev.danko.roblox_craft_ai.uikit.components.ModalDialogConfirmActions
import dev.danko.roblox_craft_ai.uikit.components.ModalDialog
import dev.danko.roblox_craft_ai.uikit.config.BackendEndpoint
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.icons.fa.FaRobot
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import dev.danko.roblox_craft_ai.components.HealthStatusBadge
import dev.danko.roblox_craft_ai.components.layouts.PageLayoutData
import dev.danko.roblox_craft_ai.shared.model.AssetResponse
import dev.danko.roblox_craft_ai.shared.model.AssetType
import dev.danko.roblox_craft_ai.shared.model.GenerationStatus
import dev.danko.roblox_craft_ai.shared.model.ProviderKeyDto
import dev.danko.roblox_craft_ai.shared.model.ProviderMetadataDto
import dev.danko.roblox_craft_ai.shared.model.TestKeyResponseV2
import dev.danko.roblox_craft_ai.shared.repository.IndexedDbAssetCacheRepository
import dev.danko.roblox_craft_ai.uikit.components.AlertVariant
import dev.danko.roblox_craft_ai.uikit.components.AppAlert
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonSize
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.AppCard
import dev.danko.roblox_craft_ai.uikit.components.AppInput
import dev.danko.roblox_craft_ai.uikit.components.AppSelect
import dev.danko.roblox_craft_ai.uikit.components.AppTabs
import dev.danko.roblox_craft_ai.uikit.components.ProviderCard
import dev.danko.roblox_craft_ai.uikit.components.SelectOption as UkSelectOption
import dev.danko.roblox_craft_ai.uikit.components.TabItem
import dev.danko.roblox_craft_ai.uikit.components.ToastManager
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import dev.danko.roblox_craft_ai.uikit.theme.toAppPalette
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import kotlin.js.Date

private val AssetCache: IndexedDbAssetCacheRepository = IndexedDbAssetCacheRepository()

private suspend fun settingsSha256Hash12(input: String): String {
    var h = 5381L
    for (c in input) {
        h = ((h shl 5) + h) + c.code.toLong()
    }
    val hex = h.toString(16).padStart(16, '0').filter { it.isLetterOrDigit() }
    val extra1 = (input.length * 2654435761L).toString(16).filter { it.isLetterOrDigit() }
    val combined = (hex + extra1).padEnd(12, '0')
    return combined.take(12)
}

val SettingsContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth().padding(leftRight = 1.cssRem, topBottom = 1.cssRem).gap(1.5.cssRem) }
    Breakpoint.MD { Modifier.maxWidth(72.cssRem).padding(leftRight = 2.cssRem, topBottom = 2.cssRem) }
}

private enum class SettingsTab(val key: String) {
    ACCOUNT("account"),
    PLUGIN("plugin"),
    GENERAL("general"),
    KEYS("keys")
}

fun settingsMaskToken(raw: String): String {
    if (raw.length < 10) return raw
    val prefix = raw.take(6)
    val suffix = raw.takeLast(4)
    return "$prefix••••$suffix"
}

private fun toastOk(text: String) = ToastManager.show(text, variant = AlertVariant.SUCCESS)
private fun toastErr(text: String) = ToastManager.show(text, variant = AlertVariant.DANGER)

@InitRoute
@Suppress("unused")
fun initSettingsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Txt.settingsPage.pageTitle))
}

@Composable
@Page("/settings")
fun SettingsPage() {
    val theme = LocalAppTheme.current
    val palette = theme.colors
    val scope = rememberCoroutineScope()

    val sessionToken = RobloxCraftApiClient.getSessionToken()
    var tokenHash12 by remember { mutableStateOf("loading...") }

    var activeTab by remember { mutableStateOf(SettingsTab.ACCOUNT) }
    var colorMode by ColorMode.currentState

    val catalog = remember { mutableStateListOf<ProviderMetadataDto>() }
    val keys = remember { mutableStateListOf<ProviderKeyDto>() }
    var prefs by remember { mutableStateOf<Map<String, String>>(emptyMap()) }
    val assets = remember { mutableStateListOf<AssetResponse>() }

    var prefDefaultModel by remember { mutableStateOf("") }
    var prefDefaultType by remember { mutableStateOf(AssetType.LUAU_SCRIPT) }
    var prefSkipSync by remember { mutableStateOf(false) }
    var prefTheme by remember { mutableStateOf("system") }
    var prefLocale by remember { mutableStateOf("ru-RU") }
    var prefPluginPort by remember { mutableStateOf("4711") }
    var prefPluginAutoConnect by remember { mutableStateOf(true) }
    var prefStudioPath by remember { mutableStateOf("") }

    var assetsFilter by remember { mutableStateOf("ALL") }
    var assetsExportProgress by remember { mutableStateOf<Int?>(null) }

    LaunchedEffect(sessionToken) {
        tokenHash12 = settingsSha256Hash12(sessionToken)
    }

    var keysManagedByServer by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        keysManagedByServer = RobloxCraftApiClient.getServerConfig()?.keysMode == "server"
    }

    LaunchedEffect(Unit) {
        try {
            catalog.clear()
            catalog.addAll(RobloxCraftApiClient.v2GetProviderCatalog())
        } catch (_: Throwable) {}
    }

    suspend fun reloadKeys() {
        try {
            val s = RobloxCraftApiClient.v2GetUserKeys()
            keys.clear()
            if (s != null) keys.addAll(s.providerKeys)
        } catch (_: Throwable) {}
    }

    suspend fun reloadPrefs() {
        try {
            val p = RobloxCraftApiClient.v2GetPreferences()
            prefs = p
            prefDefaultModel = p["defaultModelId"] ?: catalog.firstOrNull { p["defaultProviderId"] == it.providerId }?.defaultModelId ?: ""
            val typeStr = p["defaultAssetType"]
            prefDefaultType = try {
                if (!typeStr.isNullOrBlank()) AssetType.valueOf(typeStr) else AssetType.LUAU_SCRIPT
            } catch (_: Throwable) { AssetType.LUAU_SCRIPT }
            prefSkipSync = p["skipSyncConfirmations"] == "true"
            prefTheme = p["themeMode"]?.ifBlank { null } ?: "system"
            prefLocale = p["userLocale"]?.ifBlank { null } ?: "ru-RU"
            prefPluginPort = p["pluginPort"]?.ifBlank { null } ?: "4711"
            prefPluginAutoConnect = p["pluginAutoConnect"] != "false"
            prefStudioPath = p["robloxStudioInstallPath"] ?: ""
        } catch (_: Throwable) {}
    }

    LaunchedEffect(Unit) {
        reloadKeys()
        reloadPrefs()
        try {
            val cached = AssetCache.getRecent(tokenHash12, 200)
            assets.clear()
            assets.addAll(cached.sortedByDescending { it.timestamp })
        } catch (_: Throwable) {}
    }

    LaunchedEffect(tokenHash12) {
        if (tokenHash12 != "loading...") {
            try {
                val cached = AssetCache.getRecent(tokenHash12, 200)
                assets.clear()
                assets.addAll(cached.sortedByDescending { it.timestamp })
            } catch (_: Throwable) {}
        }
    }

    fun handleAddKey(providerId: String, label: String, apiKey: String, baseUrl: String?) {
        scope.launch {
            val created = RobloxCraftApiClient.v2CreateKey(providerId, label, apiKey, baseUrl)
            if (created != null) toastOk(Txt.settingsPage.keyAdded) else toastErr(Txt.settingsPage.keyAddFailed)
            reloadKeys()
        }
    }

    fun handleEditKey(keyId: String, label: String, baseUrl: String?) {
        scope.launch {
            val r = RobloxCraftApiClient.v2UpdateKey(keyId = keyId, label = label, baseUrl = baseUrl)
            if (r != null) toastOk(Txt.settingsPage.keyUpdated) else toastErr(Txt.settingsPage.keyUpdateFailed)
            reloadKeys()
        }
    }

    fun handleDeleteKey(keyId: String) {
        scope.launch {
            val ok = RobloxCraftApiClient.v2DeleteKey(keyId)
            if (ok) toastOk(Txt.settingsPage.keyDeleted) else toastErr(Txt.settingsPage.keyDeleteFailed)
            reloadKeys()
        }
    }

    fun handleToggleEnabled(keyId: String, enabled: Boolean) {
        scope.launch {
            val r = RobloxCraftApiClient.v2UpdateKey(keyId = keyId, isEnabled = enabled)
            if (r != null) reloadKeys()
        }
    }

    fun handleReorder(key: ProviderKeyDto, direction: Int) {
        scope.launch {
            val sorted = keys.sortedBy { it.priority }.toMutableList()
            val idx = sorted.indexOfFirst { it.id == key.id }
            if (idx < 0) return@launch
            val otherIdx = idx + direction
            if (otherIdx !in sorted.indices) return@launch
            val tmp = sorted[idx]
            sorted[idx] = sorted[otherIdx]
            sorted[otherIdx] = tmp
            val ok = RobloxCraftApiClient.v2ReorderKeys(sorted.map { it.id })
            if (ok) toastOk(Txt.settingsPage.priorityChanged) else toastErr(Txt.settingsPage.priorityChangeFailed)
            reloadKeys()
        }
    }

    suspend fun testSaved(keyId: String): TestKeyResponseV2 {
        return RobloxCraftApiClient.v2TestSavedKey(keyId)
    }

    suspend fun testAdhoc(providerId: String, apiKey: String, baseUrl: String?): TestKeyResponseV2 {
        return RobloxCraftApiClient.v2TestAdhocKey(providerId, apiKey, baseUrl)
    }

    Column(Modifier.fillMaxSize().backgroundColor(palette.background)) {

        SiteHeader(SiteSection.SETTINGS, subtitle = Txt.settingsPage.subtitle)

        Div(Modifier.height(1.px).fillMaxWidth().backgroundColor(palette.border).toAttrs())

        Column(
            modifier = Modifier.fillMaxWidth().backgroundColor(palette.background),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Column(SettingsContainerStyle.toModifier().fillMaxWidth().gap(1.cssRem)) {

                Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.gap(0.25.cssRem)) {
                        SpanText(
                            Txt.settingsPage.cabinetTitle,
                            Modifier.fontSize(1.35.cssRem).fontWeight(FontWeight.Bold).color(palette.textPrimary)
                        )
                        SpanText(
                            Txt.settingsPage.cabinetSubtitle,
                            Modifier.fontSize(0.82.cssRem).color(palette.textSecondary)
                        )
                    }
                }

                AppTabs(
                    tabs = listOf(
                        TabItem(SettingsTab.ACCOUNT, Txt.settingsPage.tabAccount),
                        TabItem(SettingsTab.PLUGIN, Txt.settingsPage.tabPlugin),
                        TabItem(SettingsTab.GENERAL, Txt.settingsPage.tabGeneral),
                        TabItem(SettingsTab.KEYS, Txt.settingsPage.tabKeys, count = keys.size)
                    ),
                    activeTab = activeTab,
                    onTabSelected = { activeTab = it },
                    modifier = Modifier.fillMaxWidth()
                )

                when (activeTab) {
                    SettingsTab.ACCOUNT -> TabAccount(
                        onResetSession = {
                            scope.launch {
                                if ((window.asDynamic().confirm(Txt.settingsPage.resetSessionConfirm) as? Boolean) == true) {
                                    val ok = RobloxCraftApiClient.v2DeleteSession()
                                    if (ok) {
                                        window.asDynamic().localStorage.removeItem("robloxCraft.sessionToken")
                                        ToastManager.show(Txt.settingsPage.sessionReset)
                                        delay(500)
                                        window.location.href = "/"
                                    }
                                }
                            }
                        }
                    )
                    SettingsTab.KEYS -> if (keysManagedByServer) {
                        AppAlert(
                            title = Txt.settingsPage.keysManagedByServerTitle,
                            message = Txt.settingsPage.keysManagedByServerHint,
                            variant = AlertVariant.INFO,
                            modifier = Modifier.fillMaxWidth()
                        )
                    } else TabApiKeys(
                        catalog = catalog,
                        keys = keys,
                        onAdd = ::handleAddKey,
                        onEdit = ::handleEditKey,
                        onDelete = ::handleDeleteKey,
                        onTestSaved = ::testSaved,
                        onTestAdhoc = ::testAdhoc,
                        onReorderUp = { k -> handleReorder(k, -1) },
                        onReorderDown = { k -> handleReorder(k, +1) },
                        onToggleEnabled = ::handleToggleEnabled,
                        onReload = { scope.launch { reloadKeys() } }
                    )
                    SettingsTab.GENERAL -> TabGeneral(
                        catalog = catalog,
                        keys = keys,
                        prefDefaultModel = prefDefaultModel,
                        onPrefDefaultModelChange = { prefDefaultModel = it },
                        prefDefaultType = prefDefaultType,
                        onPrefDefaultTypeChange = { prefDefaultType = it },
                        prefSkipSync = prefSkipSync,
                        onPrefSkipSyncChange = { prefSkipSync = it },
                        prefTheme = prefTheme,
                        onPrefThemeChange = { prefTheme = it },
                        prefLocale = prefLocale,
                        onPrefLocaleChange = { prefLocale = it },
                        onSave = {
                            scope.launch {
                                val r = RobloxCraftApiClient.v2PatchPreferences(
                                    defaultModelId = prefDefaultModel.ifBlank { null },
                                    skipSyncConfirmations = prefSkipSync,
                                    themeMode = prefTheme,
                                    userLocale = prefLocale
                                )
                                val ok = r["ok"] != "false"
                                if (ok) toastOk(Txt.settingsPage.settingsSaved) else toastErr(Txt.settingsPage.saveFailed)
                                reloadPrefs()
                            }
                        },
                        onReset = {
                            scope.launch {
                                val def = RobloxCraftApiClient.resetSettingsToDefaults()
                                if (def != null) toastOk(Txt.settingsPage.resetDone) else toastErr(Txt.settingsPage.resetFailed)
                                reloadPrefs()
                            }
                        }
                    )
                    SettingsTab.PLUGIN -> TabPlugin(
                        sessionToken = sessionToken,
                        tokenHash12 = tokenHash12,
                        prefPluginPort = prefPluginPort,
                        onPrefPluginPortChange = { prefPluginPort = it },
                        prefPluginAutoConnect = prefPluginAutoConnect,
                        onPrefPluginAutoConnectChange = { prefPluginAutoConnect = it },
                        prefStudioPath = prefStudioPath,
                        onPrefStudioPathChange = { prefStudioPath = it },
                        onSave = {
                            scope.launch {
                                val port = prefPluginPort.toIntOrNull() ?: 4711
                                val r = RobloxCraftApiClient.v2PatchPreferences(
                                    pluginPort = port,
                                    pluginAutoConnect = prefPluginAutoConnect,
                                    robloxStudioInstallPath = prefStudioPath.ifBlank { null }
                                )
                                val ok = r["ok"] != "false"
                                if (ok) toastOk(Txt.settingsPage.pluginSettingsSaved) else toastErr(Txt.settingsPage.saveFailed)
                                reloadPrefs()
                            }
                        },
                        onTestConnection = {
                            scope.launch {
                                try {
                                    val resp = RobloxCraftApiClient.syncRoblox(sessionToken)
                                    val msg = if (resp.activeAssets.isEmpty())
                                        Txt.settingsPage.connectionOkEmpty
                                    else
                                        Txt.settingsPage.connectionOkQueued(resp.activeAssets.size)
                                    toastOk(msg)
                                } catch (_: Throwable) {
                                    toastErr(Txt.settingsPage.connectionFailed)
                                }
                            }
                        }
                    )
                }

                Div(Modifier.height(2.cssRem).fillMaxWidth().toAttrs()) {}
            }
        }

        SiteFooter()
    }
}

@Composable
private fun MiniCheckbox(checked: Boolean, onCheckedChange: (Boolean) -> Unit, label: String, helperText: String? = null) {
    val theme = LocalAppTheme.current
    val palette = theme.colors
    Row(
        Modifier
            .fillMaxWidth()
            .gap(0.5.cssRem)
            .padding(0.5.cssRem)
            .borderRadius(theme.radii.sm)
            .cursor(Cursor.Pointer)
            .onClick { onCheckedChange(!checked) },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            Modifier
                .size(1.2.cssRem)
                .borderRadius(4.px)
                .backgroundColor(if (checked) palette.accent else palette.surface)
                .border(1.px, LineStyle.Solid, if (checked) palette.accent else palette.border),
            contentAlignment = Alignment.Center
        ) {
            if (checked) SpanText("✓", Modifier.color(Color.rgb(0xFFFFFF)).fontSize(0.7.cssRem).fontWeight(FontWeight.Bold))
        }
        Column(Modifier.gap(0.1.cssRem)) {
            SpanText(label, Modifier.color(palette.textPrimary).fontSize(0.88.cssRem).fontWeight(FontWeight.Medium))
            if (!helperText.isNullOrBlank()) {
                SpanText(helperText, Modifier.color(palette.textSecondary).fontSize(0.75.cssRem))
            }
        }
    }
}

@Composable
private fun TabApiKeys(
    catalog: List<ProviderMetadataDto>,
    keys: SnapshotStateList<ProviderKeyDto>,
    onAdd: (providerId: String, label: String, apiKey: String, baseUrl: String?) -> Unit,
    onEdit: (keyId: String, label: String, baseUrl: String?) -> Unit,
    onDelete: (keyId: String) -> Unit,
    onTestSaved: suspend (keyId: String) -> TestKeyResponseV2,
    onTestAdhoc: suspend (providerId: String, apiKey: String, baseUrl: String?) -> TestKeyResponseV2,
    onReorderUp: (ProviderKeyDto) -> Unit,
    onReorderDown: (ProviderKeyDto) -> Unit,
    onToggleEnabled: (keyId: String, Boolean) -> Unit,
    onReload: () -> Unit
) {
    val theme = LocalAppTheme.current
    val palette = theme.colors

    Column(Modifier.fillMaxWidth().gap(theme.spacing.md)) {
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            Column(Modifier.gap(0.1.cssRem)) {
                SpanText(
                    Txt.settingsPage.keysTitle,
                    Modifier.fontWeight(FontWeight.Bold).fontSize(1.cssRem).color(palette.textPrimary)
                )
                SpanText(
                    Txt.settingsPage.keysSummary(keys.size, keys.count { it.isEnabled }),
                    Modifier.fontSize(0.78.cssRem).color(palette.textSecondary)
                )
            }
            Spacer()
            AppButton(text = Txt.settingsPage.refresh, iconLeft = "🔄", variant = AppButtonVariant.OUTLINE, size = AppButtonSize.SM, onClick = onReload)
        }

        if (catalog.isEmpty()) {
            AppCard {
                Column(
                    Modifier.fillMaxWidth().padding(theme.spacing.md).gap(0.5.cssRem),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SpanText("📡", Modifier.fontSize(2.cssRem))
                    SpanText(Txt.settingsPage.catalogMissing, Modifier.color(palette.textSecondary))
                    SpanText(
                        Txt.settingsPage.catalogMissingHint,
                        Modifier.fontSize(0.78.cssRem).color(palette.textSecondary)
                    )
                }
            }
        } else {
            SpanText(
                Txt.settingsPage.providersHeader,
                Modifier.fontSize(0.85.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary)
                    .margin(top = theme.spacing.sm)
            )
            catalog.forEach { meta ->
                val providerKeys = keys.filter { it.providerId == meta.providerId }
                ProviderCard(
                    metadata = meta,
                    keys = providerKeys,
                    onAddKey = onAdd,
                    onEditKey = onEdit,
                    onDeleteKey = onDelete,
                    onTestKey = onTestSaved,
                    onTestAdhoc = onTestAdhoc,
                    onReorderUp = onReorderUp,
                    onReorderDown = onReorderDown,
                    onToggleEnabled = onToggleEnabled,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@Composable
private fun TabGeneral(
    catalog: List<ProviderMetadataDto>,
    keys: SnapshotStateList<ProviderKeyDto>,
    prefDefaultModel: String,
    onPrefDefaultModelChange: (String) -> Unit,
    prefDefaultType: AssetType,
    onPrefDefaultTypeChange: (AssetType) -> Unit,
    prefSkipSync: Boolean,
    onPrefSkipSyncChange: (Boolean) -> Unit,
    prefTheme: String,
    onPrefThemeChange: (String) -> Unit,
    prefLocale: String,
    onPrefLocaleChange: (String) -> Unit,
    onSave: () -> Unit,
    onReset: () -> Unit
) {
    val theme = LocalAppTheme.current
    val palette = theme.colors

    val modelOptions: List<UkSelectOption<String>> = remember(catalog, keys) {
        val enabled = keys.filter { it.isEnabled }
        val list = enabled.mapNotNull { k ->
            val meta = catalog.firstOrNull { it.providerId == k.providerId } ?: return@mapNotNull null
            UkSelectOption(
                value = meta.defaultModelId,
                label = "${meta.iconEmoji} ${meta.displayName} · ${meta.defaultModelId}"
            )
        }
        if (list.isEmpty()) listOf(UkSelectOption(value = "", label = Txt.settingsPage.noModels)) else list
    }

    AppCard {
        Column(Modifier.fillMaxWidth().padding(theme.spacing.md).gap(theme.spacing.md)) {
            SpanText(Txt.settingsPage.generalTitle, Modifier.fontWeight(FontWeight.Bold).fontSize(1.cssRem))

            AppSelect(
                options = modelOptions,
                selected = prefDefaultModel.ifBlank { null },
                onSelect = onPrefDefaultModelChange,
                label = Txt.settingsPage.defaultModel,
                placeholder = Txt.settingsPage.selectModel,
                modifier = Modifier.fillMaxWidth()
            )

            AppSelect(
                options = AssetType.values().map { t ->
                    val emoji = when (t) {
                        AssetType.LUAU_SCRIPT -> "📜"
                        AssetType.MESH_3D -> "🧊"
                        AssetType.ANIMATION -> "🎞"
                        AssetType.ROJO_PROJECT -> "🔧"
                    }
                    UkSelectOption(value = t, label = "$emoji ${Txt.assetTypes.name(t)}")
                },
                selected = prefDefaultType,
                onSelect = onPrefDefaultTypeChange,
                label = Txt.settingsPage.defaultAssetType,
                modifier = Modifier.fillMaxWidth()
            )

            MiniCheckbox(
                checked = prefSkipSync,
                onCheckedChange = onPrefSkipSyncChange,
                label = Txt.settingsPage.skipSyncConfirm,
                helperText = Txt.settingsPage.skipSyncConfirmHint
            )

            AppSelect(
                options = listOf(
                    UkSelectOption("system", Txt.settingsPage.themeSystem),
                    UkSelectOption("light", Txt.settingsPage.themeLight),
                    UkSelectOption("dark", Txt.settingsPage.themeDark)
                ),
                selected = prefTheme,
                onSelect = onPrefThemeChange,
                label = Txt.settingsPage.themeLabel,
                modifier = Modifier.fillMaxWidth()
            )

            AppSelect(
                options = AppLocale.entries.map { locale -> UkSelectOption(locale.code, locale.nativeName) },
                selected = AppLocale.fromCode(prefLocale)?.code ?: LocaleController.current.code,
                onSelect = { code ->
                    onPrefLocaleChange(code)
                    AppLocale.fromCode(code)?.let { LocaleController.select(it) }
                },
                label = Txt.settingsPage.languageLabel,
                modifier = Modifier.fillMaxWidth()
            )

            Div(Modifier.height(1.px).fillMaxWidth().backgroundColor(palette.border).toAttrs())

            Row(Modifier.fillMaxWidth().gap(theme.spacing.sm), horizontalArrangement = Arrangement.End) {
                AppButton(text = Txt.settingsPage.reset, iconLeft = "↩", variant = AppButtonVariant.SECONDARY, size = AppButtonSize.MD, onClick = onReset)
                AppButton(text = Txt.common.save, iconLeft = "💾", variant = AppButtonVariant.PRIMARY, size = AppButtonSize.MD, onClick = onSave)
            }
        }
    }
}

@Composable
private fun TabPlugin(
    sessionToken: String,
    tokenHash12: String,
    prefPluginPort: String,
    onPrefPluginPortChange: (String) -> Unit,
    prefPluginAutoConnect: Boolean,
    onPrefPluginAutoConnectChange: (Boolean) -> Unit,
    prefStudioPath: String,
    onPrefStudioPathChange: (String) -> Unit,
    onSave: () -> Unit,
    onTestConnection: () -> Unit
) {
    val palette = LocalAppTheme.current.colors
    var advancedOpen by remember { mutableStateOf(false) }

    Column(Modifier.fillMaxWidth().gap(16.px)) {
        AppCard(Modifier.fillMaxWidth()) {
            Column(Modifier.fillMaxWidth().padding(4.px).gap(14.px)) {
                SpanText(Txt.settingsPage.howToConnectTitle.removePrefix("📚 "), Modifier.fontWeight(FontWeight.Bold).fontSize(17.px).color(palette.textPrimary))
                Txt.settingsPage.howToConnectSteps.forEachIndexed { index, step ->
                    Row(Modifier.fillMaxWidth().gap(12.px), verticalAlignment = Alignment.Top) {
                        Box(
                            Modifier.size(28.px).flexShrink(0).borderRadius(50.percent).backgroundColor(palette.surfaceElevated)
                                .color(palette.accentText).fontWeight(FontWeight.Bold).fontSize(13.px),
                            contentAlignment = Alignment.Center
                        ) { SpanText("${index + 1}") }
                        SpanText(
                            step.replace(Regex("^\\d+\\.\\s*"), ""),
                            Modifier.fontSize(14.px).lineHeight(1.55).color(palette.textPrimary).padding(top = 3.px)
                        )
                    }
                }
                // Served by the backend with this server's address already filled in.
                AppButton(
                    text = Txt.settingsPage.downloadPlugin,
                    icon = AppIcon.DOWNLOAD,
                    onClick = { window.location.href = BackendEndpoint.http("/api/v1/plugin/RobloxCraftPlugin.lua") },
                    modifier = Modifier.width(com.varabyte.kobweb.compose.css.Width.FitContent)
                )
            }
        }

        AppCard(Modifier.fillMaxWidth()) {
            Column(Modifier.fillMaxWidth().padding(4.px).gap(12.px)) {
                SpanText(Txt.settingsPage.pluginTokenTitle, Modifier.fontWeight(FontWeight.Bold).fontSize(15.px).color(palette.textPrimary))
                Row(
                    Modifier.fillMaxWidth().padding(12.px).gap(12.px).borderRadius(12.px).backgroundColor(palette.background)
                        .border(1.px, LineStyle.Solid, palette.border),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        sessionToken,
                        Modifier.flexGrow(1).minWidth(0.px).fontFamily("JetBrains Mono", "ui-monospace", "monospace").fontSize(14.px)
                            .color(palette.textPrimary).styleModifier { property("word-break", "break-all") }
                    )
                    AppButton(
                        text = Txt.common.copy,
                        icon = AppIcon.COPY,
                        variant = AppButtonVariant.SECONDARY,
                        size = AppButtonSize.SM,
                        onClick = {
                            window.navigator.asDynamic().clipboard.writeText(sessionToken)
                            ToastManager.show(Txt.settingsPage.tokenCopied)
                        }
                    )
                }
                Row(Modifier.gap(8.px).flexWrap(FlexWrap.Wrap)) {
                    AppButton(text = Txt.settingsPage.testConnection, variant = AppButtonVariant.PRIMARY, onClick = onTestConnection)
                    AppButton(
                        text = Txt.settingsPage.advanced,
                        icon = AppIcon.CHEVRON_DOWN,
                        variant = AppButtonVariant.GHOST,
                        onClick = { advancedOpen = !advancedOpen }
                    )
                }
                if (advancedOpen) {
                    Column(Modifier.fillMaxWidth().gap(14.px).padding(top = 8.px)) {
                        AppInput(
                            value = prefPluginPort,
                            onValueChanged = { v -> onPrefPluginPortChange(v.filter { it.isDigit() }.take(5)) },
                            label = Txt.settingsPage.pluginPort,
                            placeholder = "4711",
                            helperText = Txt.settingsPage.pluginPortHint,
                            modifier = Modifier.fillMaxWidth()
                        )
                        MiniCheckbox(
                            checked = prefPluginAutoConnect,
                            onCheckedChange = onPrefPluginAutoConnectChange,
                            label = Txt.settingsPage.autoConnect,
                            helperText = Txt.settingsPage.autoConnectHint
                        )
                        AppInput(
                            value = prefStudioPath,
                            onValueChanged = onPrefStudioPathChange,
                            label = Txt.settingsPage.studioPath,
                            placeholder = "/Applications/RobloxStudio.app",
                            modifier = Modifier.fillMaxWidth()
                        )
                        SpanText(
                            "${Txt.settingsPage.sessionHashTitle}: ${tokenHash12.take(12)}",
                            Modifier.fontSize(12.px).color(palette.textSecondary)
                        )
                        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                            AppButton(text = Txt.common.save, variant = AppButtonVariant.SECONDARY, onClick = onSave)
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TabAccount(onResetSession: () -> Unit) {
    val palette = LocalAppTheme.current.colors
    val scope = rememberCoroutineScope()
    val user = AuthState.user
    Column(Modifier.fillMaxWidth().gap(16.px)) {
        AppCard(Modifier.fillMaxWidth()) {
            if (user == null) {
                Column(Modifier.fillMaxWidth().padding(4.px).gap(10.px)) {
                    SpanText(Txt.settingsPage.signedOutTitle, Modifier.fontWeight(FontWeight.Bold).fontSize(17.px).color(palette.textPrimary))
                    SpanText(Txt.settingsPage.signedOutHint, Modifier.fontSize(14.px).color(palette.textSecondary))
                    AppButton(text = Txt.auth.signIn, icon = AppIcon.USER, onClick = { AuthState.loginDialogOpen = true }, modifier = Modifier.alignSelf(com.varabyte.kobweb.compose.css.AlignSelf.FlexStart))
                }
            } else {
                Column(Modifier.fillMaxWidth().padding(4.px).gap(14.px)) {
                    Row(Modifier.gap(14.px), verticalAlignment = Alignment.CenterVertically) {
                        Box(
                            Modifier.size(48.px).borderRadius(50.percent).backgroundColor(palette.surfaceElevated).color(palette.accentText)
                                .fontWeight(FontWeight.Bold).fontSize(18.px),
                            contentAlignment = Alignment.Center
                        ) { SpanText(user.email.take(1).uppercase()) }
                        Column(Modifier.gap(2.px)) {
                            SpanText(user.email, Modifier.fontWeight(FontWeight.Bold).fontSize(16.px).color(palette.textPrimary))
                            AuthState.planId?.let { SpanText(Txt.nav.plan(it.replaceFirstChar { c -> c.uppercase() }), Modifier.fontSize(14.px).color(palette.textSecondary)) }
                        }
                    }
                    val usage = AuthState.usage
                    val limit = usage?.creditsLimit
                    if (usage != null && limit != null) {
                        val left = (limit - usage.creditsUsed).coerceAtLeast(0)
                        Column(Modifier.fillMaxWidth().padding(14.px).gap(8.px).borderRadius(12.px).backgroundColor(palette.background)) {
                            SpanText(Txt.billing.balance(left.toString(), usage.purchasedCredits), Modifier.fontSize(14.px).color(palette.textPrimary))
                            Box(Modifier.fillMaxWidth().height(6.px).borderRadius(999.px).backgroundColor(palette.border).overflow(Overflow.Hidden)) {
                                Box(Modifier.width((left * 100.0 / limit.coerceAtLeast(1)).percent).height(6.px).backgroundColor(palette.accent))
                            }
                        }
                    }
                    Row(Modifier.gap(8.px).flexWrap(FlexWrap.Wrap)) {
                        AppButton(text = Txt.billing.title, icon = AppIcon.ZAP, variant = AppButtonVariant.SECONDARY, onClick = { window.location.href = "/pricing" })
                        AppButton(text = Txt.auth.signOut, icon = AppIcon.LOG_OUT, variant = AppButtonVariant.GHOST, onClick = {
                            scope.launch {
                                AuthState.signOut()
                                ToastManager.info(Txt.auth.signedOut)
                            }
                        })
                    }
                }
            }
        }
        if (user != null) YourDataCard(user.email)
        AppCard(Modifier.fillMaxWidth()) {
            Column(Modifier.fillMaxWidth().padding(4.px).gap(10.px)) {
                SpanText(Txt.settingsPage.dangerZone, Modifier.fontWeight(FontWeight.Bold).fontSize(15.px).color(palette.textPrimary))
                SpanText(Txt.settingsPage.resetSessionHint, Modifier.fontSize(14.px).color(palette.textSecondary))
                AppButton(
                    text = Txt.settingsPage.resetSession,
                    variant = AppButtonVariant.DANGER,
                    size = AppButtonSize.SM,
                    onClick = onResetSession,
                    modifier = Modifier.alignSelf(com.varabyte.kobweb.compose.css.AlignSelf.FlexStart)
                )
            }
        }
    }
}

/** Download everything stored about the account, or delete it for good (confirmed by typing the email). */
@Composable
private fun YourDataCard(email: String) {
    val s = Txt.accountData
    val palette = LocalAppTheme.current.colors
    val scope = rememberCoroutineScope()
    var dialogOpen by remember { mutableStateOf(false) }
    var typed by remember { mutableStateOf("") }
    var deleting by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }

    AppCard(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().padding(4.px).gap(10.px)) {
            SpanText(s.title, Modifier.fontWeight(FontWeight.Bold).fontSize(15.px).color(palette.textPrimary))
            SpanText(s.hint, Modifier.fontSize(14.px).color(palette.textSecondary))
            Row(Modifier.gap(8.px).flexWrap(FlexWrap.Wrap)) {
                AppButton(
                    text = s.download,
                    icon = AppIcon.DOWNLOAD,
                    variant = AppButtonVariant.SECONDARY,
                    size = AppButtonSize.SM,
                    onClick = { window.location.href = BackendEndpoint.http("/api/v1/account/export") }
                )
                AppButton(text = s.delete, icon = AppIcon.TRASH, variant = AppButtonVariant.DANGER, size = AppButtonSize.SM, onClick = {
                    typed = ""
                    error = null
                    dialogOpen = true
                })
            }
        }
    }

    ModalDialog(
        visible = dialogOpen,
        onCloseRequest = { if (!deleting) dialogOpen = false },
        title = s.deleteTitle,
        footer = ModalDialogConfirmActions(
            confirmText = s.confirmButton,
            onConfirm = {
                deleting = true
                scope.launch {
                    when (RobloxCraftApiClient.deleteAccount(typed.trim())) {
                        null -> {
                            ToastManager.success(s.deleted)
                            AuthState.signOut()
                            window.location.href = "/"
                        }
                        "EMAIL_MISMATCH" -> error = s.emailMismatch
                        "SUBSCRIPTION_ACTIVE" -> error = s.subscriptionActive
                        else -> error = s.failed
                    }
                    deleting = false
                }
            },
            onCancel = { dialogOpen = false },
            confirmVariant = AppButtonVariant.DANGER,
            confirmLoading = deleting,
            // The button unlocks only for the account's own email, typed in full.
            confirmEnabled = !deleting && typed.trim().equals(email, ignoreCase = true)
        )
    ) {
        Column(Modifier.fillMaxWidth().gap(12.px)) {
            SpanText(s.deleteWarning, Modifier.fontSize(14.px).lineHeight(1.5).color(palette.textSecondary))
            AppInput(value = typed, onValueChanged = { typed = it; error = null }, label = s.confirmLabel, placeholder = email, error = error, disabled = deleting)
        }
    }
}
